import TeamspaceImg from '@/shared/assets/images/teamspaces-upgrade-banner.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock Teamspaces',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  checkIsSpaceOwner: false,
  features: getBullets([
    'teamspaceCreatorPro',
    'translate100',
    'lipSync',
    'voiceCloneSettings',
    'voicePresets',
    'srtUploadDownload',
    'subtitles',
    'aiRewrite',
    'simultaneousMultiLanguageTranslation',
  ]),
  media: {
    src: TeamspaceImg,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.teamSpaceUpgradeClick,
  mixpanelOpeningEvent: MixpanelEvents.upgradeTeamspaceModalShown,
  subtitle: 'Upgrade to Creator Pro to have Teamspace with up to 3 members',
};

const CREATOR_PRO_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreatorPro,
  buttonText: BUTTON_TEXTS.toBusiness,
  features: getBullets([
    'teamspaceBusiness',
    'translate500',
    'voicePresets10',
    'glossary',
    'simultaneousMultiLanguageTranslation',
    'api',
  ]),
  subtitle: 'Upgrade to Business to have Teamspace with up to 5 members',
};

const BUSINESS_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inBusiness,
  buttonText: BUTTON_TEXTS.contactUs,
  features: getBullets([
    'teamspace',
    'translate2000',
    'voicePresetsUnlimited',
    'customPriceForMins',
    'humanInTheLoop',
    'businessContract',
    'personalManager',
  ]),
  mixpanelButtonClickEvent: MixpanelEvents.upgradeTeamspaceModalClickContactUs,
  subtitle: 'Upgrade to Enterprise to have unlimited Teamspaces and members',
};

const SCALE_TEAM: ModalContent = {
  title: 'Looking to scale your team?',
  bulletsHeader: '',
  buttonText: BUTTON_TEXTS.contactUs,
  features: [],
  media: {
    src: TeamspaceImg,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.upgradeTeamspaceModalClickContactUs,
  mixpanelOpeningEvent: MixpanelEvents.upgradeTeamspaceModalShown,
  subtitle: 'Contact us to find the right number of Teamspaces and members for your team.',
};

export const TEAMSPACE_CONTENT: LimitedFeatureContent = {
  business: BUSINESS_PLAN_CONTENT,
  creator: BASE_CONTENT,
  creatorPro: CREATOR_PRO_PLAN_CONTENT,
  custom: SCALE_TEAM,
  enterprise: BUSINESS_PLAN_CONTENT,
  starter: BASE_CONTENT,
  trial: BASE_CONTENT,
};
